import React from "react";
import { Provider } from "react-redux";
import { createStore, applyMiddleware, compose, combineReducers } from "redux";
import createSagaMiddleware from "redux-saga";
import ReduxThunk from "redux-thunk";

import plaseBlokkeReducer from "./store/reducers/plase-blokke";
import uiReducer from "./store/reducers/ui";
import mapReducer from "./store/reducers/map";
import layersReducer from "./store/reducers/layers";
import layersReducer_verkenning from "./store/reducers/layers_verkenning";
import layersReducer_custom from "./store/reducers/layers_custom";
import layersReducer_legacy from "./store/reducers/layers_legacy";
import editmodeReducer from "./store/reducers/editmode";
import takeReducer from "./store/reducers/take";
import instruksiesReducer from "./store/reducers/instruksies";
import notificationsReducer from "./store/reducers/notifications";
import plukbeplannerReducer from "./store/reducers/plukbeplanner";
import {
  watchKryPlase,
  watchKryAlleBlokke,
  watchKryBlokke,
  watchKryPlaas,
  watchKryBlok,
  watchKiesPlaas,
  watchKryCurrentLocation,
  watchKryLayerslys,
  watchKiesLayer,
  watchVeranderLayerFilter,
  watchKryTakeCards,
  watchKryTakeCardsPerLane,
  watchSetTaakIndex,
  watchKryInstruksiesCards,
  watchInstrInvulKryInstruksie,
  watchInstrInvulKryInstruksieIngevul,
  watchKryLayerslys_verkenning,
  watchKiesLayer_verkenning,
  watchVeranderLayerFilter_verkenning,
  watchKryLayerslys_legacy,
  watchKiesLayer_legacy,
  watchVeranderLayerFilter_legacy,
  watchKryNotifications,
  watchMerkNotificationGelees,
  watchKryEenheidVerh,
  watchListenToFeatureClick,
  watchStoorCustomLayer,
  watchEditCustomLayer,
  watchLayersLysCustom,
  watchKiesLayer_custom,
  watchKiesLayerVersion_custom,
  watchSkepTempDrawLayer,
  watchStoorLayerVersionCustom,
  watchReloadCustomLayersLys,
  watchKanselleerCustomLayerVersionSaga,
  watchSetLayerEditableSaga,
  watchDeleteCustomLayerVersion,
  watchStoorLayerNaamSage,
  watchResubscribeSaga,
  watchGetIcons_CustomLayers,
  watchGetKultivarsSaga_Plukbepl,
  watchGetWeekSaga_Plukbepl,
  watchGetWeekDaeSaga_Plukbepl,
  watchGetOpstellingsSaga_Plukbepl,
  watchSetOpstellings_WeekBegin_Saga_Plukbepl,
  watchSetOpstellings_ViewEenheid_Saga_Plukbepl,
  watchSetWeekTeikenSaga_Plukbepl,
  watchSetDagTeikenSaga_Plukbepl,
  watchSetDagItemSaga_Plukbepl,
} from "./store/sagas";
import { reduxEventReducer } from "react-redux-events";

import asyncDispatchMiddleware from "./store/middleware/asyncDispatchMiddleware";

import { reducer as toastrReducer } from "react-redux-toastr";
import "react-redux-toastr/lib/css/react-redux-toastr.min.css";

const rootReducer = combineReducers({
  plaseBlokke: plaseBlokkeReducer,
  ui: uiReducer,
  map: mapReducer,
  layers: layersReducer,
  layers_verkenning: layersReducer_verkenning,
  layers_custom: layersReducer_custom,
  layers_legacy: layersReducer_legacy,
  editmode: editmodeReducer,
  reactReduxEvents: reduxEventReducer,
  take: takeReducer,
  instruksies: instruksiesReducer,
  toastr: toastrReducer,
  notifications: notificationsReducer,
  plukbeplanner: plukbeplannerReducer,
});

const sagaMiddleware = createSagaMiddleware();

const actionSanitizer = (action) => (
  action.type === 'FILE_DOWNLOAD_SUCCESS' && action.data ?
    { ...action, data: '<<LONG_BLOB>>' } : action
);

const composeEnhancers =
  typeof window === 'object' &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
      actionSanitizer,
      stateSanitizer: (state) => state.data ? { ...state, data: '<<LONG_BLOB>>' } : state
    }) : compose;

const store = createStore(
  rootReducer,
  composeEnhancers(
    applyMiddleware(ReduxThunk, sagaMiddleware, asyncDispatchMiddleware)
  )
);

sagaMiddleware.run(watchKryPlase);
sagaMiddleware.run(watchKryAlleBlokke);
sagaMiddleware.run(watchKryBlokke);
sagaMiddleware.run(watchKryPlaas);
sagaMiddleware.run(watchKryBlok);
sagaMiddleware.run(watchKiesPlaas);
sagaMiddleware.run(watchKryCurrentLocation);
sagaMiddleware.run(watchKryEenheidVerh);

sagaMiddleware.run(watchKryLayerslys);
sagaMiddleware.run(watchKiesLayer);
sagaMiddleware.run(watchVeranderLayerFilter);

sagaMiddleware.run(watchKryLayerslys_verkenning);
sagaMiddleware.run(watchKiesLayer_verkenning);
sagaMiddleware.run(watchVeranderLayerFilter_verkenning);

sagaMiddleware.run(watchKryLayerslys_legacy);
sagaMiddleware.run(watchKiesLayer_legacy);
sagaMiddleware.run(watchVeranderLayerFilter_legacy);

sagaMiddleware.run(watchKryTakeCards);
sagaMiddleware.run(watchKryTakeCardsPerLane);
sagaMiddleware.run(watchSetTaakIndex);

sagaMiddleware.run(watchKryInstruksiesCards);
sagaMiddleware.run(watchInstrInvulKryInstruksie);
sagaMiddleware.run(watchInstrInvulKryInstruksieIngevul);

sagaMiddleware.run(watchKryNotifications);
sagaMiddleware.run(watchMerkNotificationGelees);

sagaMiddleware.run(watchListenToFeatureClick);
sagaMiddleware.run(watchStoorCustomLayer);
sagaMiddleware.run(watchEditCustomLayer);
sagaMiddleware.run(watchLayersLysCustom);
sagaMiddleware.run(watchKiesLayer_custom);
sagaMiddleware.run(watchKiesLayerVersion_custom);
sagaMiddleware.run(watchSkepTempDrawLayer);
sagaMiddleware.run(watchStoorLayerVersionCustom);
sagaMiddleware.run(watchReloadCustomLayersLys);
sagaMiddleware.run(watchKanselleerCustomLayerVersionSaga);
sagaMiddleware.run(watchSetLayerEditableSaga);
sagaMiddleware.run(watchDeleteCustomLayerVersion);
sagaMiddleware.run(watchStoorLayerNaamSage);
sagaMiddleware.run(watchResubscribeSaga);
sagaMiddleware.run(watchGetIcons_CustomLayers);
sagaMiddleware.run(watchGetKultivarsSaga_Plukbepl);
sagaMiddleware.run(watchGetWeekSaga_Plukbepl);
sagaMiddleware.run(watchGetWeekDaeSaga_Plukbepl);
sagaMiddleware.run(watchGetOpstellingsSaga_Plukbepl);
sagaMiddleware.run(watchSetOpstellings_WeekBegin_Saga_Plukbepl);
sagaMiddleware.run(watchSetOpstellings_ViewEenheid_Saga_Plukbepl);
sagaMiddleware.run(watchSetWeekTeikenSaga_Plukbepl);
sagaMiddleware.run(watchSetDagTeikenSaga_Plukbepl);
sagaMiddleware.run(watchSetDagItemSaga_Plukbepl);

const StoreHolder = (props) => {
  return <Provider store={store}>{props.children}</Provider>;
};

export default StoreHolder;
